<div class="progress-header">
  <span class="progress-header__label" id="layout-header">
    Based on the program you are signing up for, there are a few things that you
    might want to purchase.
  </span>
  <span class="progress-header__page-count">
    {{ currentPage$ | async }} of {{ totalGroups$ | async }}
  </span>
</div>
<se-fe-progress-bar
  [attr.aria-label]="
    'Page ' + (currentPage$ | async) + ' of ' + (totalGroups$ | async)
  "
  class="progress-bar"
  [seFeDataTotal]="(totalGroups$ | async)!"
  [seFeDataCompleted]="(currentPage$ | async)!"></se-fe-progress-bar>
<se-fe-page>
  <div seFePageHeader tabindex="0" role="banner">
    <app-add-on-header
      class="add-on-header"
      [previousRoute]="(previousRouteId$ | async)!"
      [cartSubtotal]="(cartSubtotal$ | async)!"
      [enableCart]="(enableCart$ | async)!"
      (cartClick)="showCart()"
      [showUpfrontText]="(showUpfrontText$ | async)!"></app-add-on-header>
    <app-page-title class="add-on-title"></app-page-title>
  </div>
  <div seFePageContent role="main" aria-label="add-on" class="layout-outlet">
    <router-outlet></router-outlet>
  </div>
</se-fe-page>

<se-fe-side-panel
  [seFeDataVisible]="(showCart$ | async)!"
  (seFeClose)="hideCart()"
  class="cart-side-panel">
  <se-fe-header
    class="cart-side-panel__header"
    data-testid="shopping-cart-header"
    seFeSidePanelHeader
    [seFeDataTitle]="'Shopping Cart'">
    <se-fe-icon-button
      class="shopping-cart-close-button"
      seFeHeaderActions
      (click)="hideCart()"
      data-testid="shopping-cart-close-button"
      seFeDataEmphasis="low">
      <se-fe-icon
        seFeDataName="close"
        seFeDataSize="700"
        seFeDataColor="default"
        seFeDataAriaLabel="Close"></se-fe-icon>
    </se-fe-icon-button>
  </se-fe-header>

  <app-cart-slide seFeSidePanelContent [useProjection]="true">
    <se-fe-button
      seFeDataEmphasis="medium"
      [seFeDataFullWidth]="true"
      (click)="hideCart()">
      Close Shopping Cart
    </se-fe-button>
    <se-fe-button
      seFeDataEmphasis="medium"
      [seFeDataFullWidth]="true"
      (click)="continueClick()">
      Continue to next step
    </se-fe-button>
  </app-cart-slide>
</se-fe-side-panel>

<se-fe-toast></se-fe-toast>
